<mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
    <!-- <mat-card-header>
        <app-card-title>{{ "general_information" | translate }}</app-card-title>
    </mat-card-header> -->
    <mat-card-content class="card-content">
        <table class="table table-bordered">
            <colgroup>
                <col style="width:20%">
                <col style="width:40%">
                <col style="width:20%">
                <col style="width:20%">
            </colgroup>
            <tbody>
            <tr>
                <th class="table-active">{{ "qna_num_reception" | translate }}</th>
                <td colspan="3">{{ item.rcvNo }}</td>
            </tr>
            <tr>
                <th class="table-active"> {{ "faq_redacteur" | translate }}</th>
                <td colspan="3">{{ item.writerNm }}</td>
            </tr>
            <tr>
                <th class="table-active">{{ "Lieu_de_travail" | translate }}</th>
                <td>{{ item.sectorNm }}</td>
                <th class="table-active">{{ "Type_du_demandeur" | translate }}</th>
                <td> {{ item.writerCdNmAr }}</td>
            </tr>

            <tr>
                <th class="table-active">{{ "Email" | translate }}</th>
                <td colspan="3">{{ item.email }}</td>
            </tr>
            <tr>
                <th class="table-active">{{ "num_téléphone" | translate }}</th>
                <td colspan="3">{{ item.telNo }}</td>
            </tr>

            <tr>
                <th class="table-active"> {{ "modDt_rédaction" | translate }}</th>
                <td>{{ item.regDt | date : 'dd/MM/yyyy ' }}<br></td>
                <th class="table-active"> {{ "nb_consult" | translate }}</th>
                <td>{{ item.hitCnt }}</td>
            </tr>
            <tr>
                <th class="table-active">{{ "qna_classification" | translate }}</th>
                <td colspan="3"> {{ item.qnaSubClNmAr }}</td>
            </tr>
            <tr>
                <th class="table-active">{{ "Sous_Classification" | translate }}</th>
                <td colspan="3">{{ item.qnaCdNmAr }}</td>
            </tr>
            <tr>
                <th class="table-active">{{ "faq_title" | translate }}</th>
                <td colspan="3">


                    {{ item.title }}
                </td>
            </tr>
            <tr>
                <th class="table-active">{{ "Contenus" | translate }}</th>
                <td colspan="3" height="165px" style="vertical-align:top;">
                    <div #frContainer></div>


                </td>
            </tr>
            <!-- <tr>
                 <th>Fichier attaché</th>
                <td colspan="3">

                </td>
            </tr> -->

            </tbody>
        </table>

    </mat-card-content>

    <div *ngIf="current_lang=='fr'|| current_lang=='en'" align="right">
        <button [routerLink]="['/portail/qna']" mat-raised-button
                style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
    </div>
    <div *ngIf="current_lang=='ar'" style="float: left;">
        <button [routerLink]="['/portail/qna']" mat-raised-button
                style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
    </div>

</mat-card>
